<script module lang="ts">
	export interface FooterLink {
		label: string;
		href: string;
		newTab?: boolean;
	}
</script>

<script lang="ts">
	import { twMerge } from 'tailwind-merge';
	import { Link } from '$global/components/Link';
	import { Txt } from '$global/components/Txt';
	import { toKebabCase } from '$global/utils/toKebabCase';

	interface Props {
		dataCy: string;
		links: FooterLink[];
		title: string;
		class?: string;
		listClass?: string;
	}

	let { ...props }: Props = $props();
</script>

<div
	class={twMerge(
		'flex w-full flex-col items-start md:items-center',
		props.class
	)}
>
	<div class={twMerge('grid gap-y-5', props.listClass)}>
		<Txt
			variant="label2"
			class="col-span-full flex w-full flex-col justify-between text-gray-50"
			>{props.title}</Txt
		>

		{#each props.links as { label, href, newTab }}
			<Link
				{href}
				{...newTab ? { rel: 'noopener noreferrer', target: '_blank' } : {}}
			>
				<Txt
					dataCy={`${props.dataCy}-${toKebabCase(label)}`}
					variant="label2"
					class="flex w-full flex-col justify-between font-normal text-gray-500"
					>{label}</Txt
				>
			</Link>
		{/each}
	</div>
</div>
